import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  LijfrentePremie
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-premies-aov',
  templateUrl: './premies-aov.component.html',
  styleUrls: ['./premies-aov.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    CommonModule,
    SharedUiDetailsModule
  ]
})
export class PremiesAovComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription | undefined;
  private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
  private isDefAangifteSubscription: Subscription | undefined;
  private isSaving = false;
  @Input() public id!: string;
  public clientId!: string;
  public aangifte = {} as Aangifte;
  public incomeTaxEntity = {} as IncomeTaxEntity;

  public partnerBoolean = {} as boolean;
  @Input() partner = new BehaviorSubject<boolean>(false);
  private partnerAangifte = {} as Aangifte;

  public isDefAangifte = {} as boolean;

  private focusedElementId: string | null = null;

  public premieAOV = {} as FormGroup;

  constructor(
    public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
    private router: Router,
    private fb: FormBuilder,
  ) {
    this.premieAOV = this.fb.group({
      betaaldePremieAOV: this.fb.array<LijfrentePremie>([]),
    });
  }

  get betaaldePremieAOV(): FormArray {
    return this.premieAOV.get('betaaldePremieAOV') as FormArray;
  }

  addRijLoonPremieAOV(): void {
    this.betaaldePremieAOV.push(this.createPremieAOVFormGroup());
  }

  verwijderRijPremieAOV(index: number): void {
    this.betaaldePremieAOV.removeAt(index);
    this.premieAOV.updateValueAndValidity()
    this.premieAOV.markAsDirty()
    this.saveForm();
  }

  createPremieAOVFormGroup(premie?: LijfrentePremie): FormGroup {
    return this.fb.group({
      omschrijving: premie ? premie?.omschrijving : undefined,
      bedrag: premie ? premie.bedrag : undefined,
      polisnummer: premie ? premie.polisnummer : undefined,
    } as LijfrentePremie);
  }

  public ngOnInit(): void {
    this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
      this.isDefAangifte = isDefAangifte;
    });
    this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
      this.incomeTaxEntity = incomeTaxEntity;
      if (incomeTaxEntity.aangifte) {
        const aangifte = incomeTaxEntity.aangifte;
        this.aangifte = aangifte;
        this.partnerAangifte = aangifte.partnerAangifte
          ? aangifte.partnerAangifte
          : ({} as Aangifte);
        this.updateForm();
        this.partner.subscribe((partner) => {
          this.partnerBoolean = partner;
          this.premieAOV.reset();
          this.updateForm();
        });
      }
    });
    this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
      this.clientId=client.sstRelationId!;
    })
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        this.handleUrlChange(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
    if (this.isDefAangifteSubscription) {
      this.isDefAangifteSubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.premieAOV.dirty
  }
  private updateForm(): void {
    let premieAOVLijst =
      this.aangifte?.box1?.uitgavenVoorInkomensvoorzieningen
        ?.lijfrentePremiesAOV || [];
    this.partner.subscribe((partner) => {
      if (partner) {
        premieAOVLijst =
          this.aangifte?.partnerAangifte?.box1
            ?.uitgavenVoorInkomensvoorzieningen?.lijfrentePremiesAOV || [];
      }
    });
    const formArrayAOV = this.premieAOV.get('betaaldePremieAOV') as FormArray;
    const focusedControl = this.focusedElementId
      ? (document.getElementById(this.focusedElementId) as HTMLElement)
      : null;
    while (
      formArrayAOV != null &&
      formArrayAOV.length > premieAOVLijst.length
    ) {
      formArrayAOV.removeAt(formArrayAOV.length - 1);
    }

    for (let i = 0; i < premieAOVLijst.length; i++) {
      if (i < formArrayAOV.length) {
        const control = formArrayAOV.at(i) as FormGroup;
        control.patchValue(premieAOVLijst[i]);
      } else {
        const formGroup = this.createPremieAOVFormGroup(premieAOVLijst[i]);
        formArrayAOV.push(formGroup);
      }
    }

    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
  }

  saveForm(): void {
    if (!this.partnerBoolean) {
      this.incomeTaxEntity.aangifte = {
        ...this.aangifte,
        box1: {
          ...this.aangifte.box1,
          uitgavenVoorInkomensvoorzieningen: {
            ...this.aangifte.box1?.uitgavenVoorInkomensvoorzieningen,
            lijfrentePremiesAOV: this.premieAOV.value.betaaldePremieAOV,
          },
        },
      } as Aangifte;
      this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    } else {
      this.incomeTaxEntity.aangifte = {
        ...this.aangifte,
        partnerAangifte: {
          ...this.aangifte.partnerAangifte,
          box1: {
            ...this.aangifte.partnerAangifte?.box1,
            uitgavenVoorInkomensvoorzieningen: {
              ...this.aangifte.partnerAangifte?.box1
                ?.uitgavenVoorInkomensvoorzieningen,
              lijfrentePremiesAOV: this.premieAOV.value.betaaldePremieAOV,
            },
          },
        },
      } as Aangifte;
      this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }
  }
}

